/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAvro = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V11h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M21.117 12.925c.396 0 .734.082 1.013.247.279.161.49.396.638.704.146.308.22.682.22 1.122 0 .664-.162 1.177-.484 1.54-.323.36-.786.54-1.387.54-.597 0-1.06-.18-1.386-.54-.322-.363-.483-.876-.483-1.54 0-.44.073-.814.22-1.122.146-.308.359-.543.637-.704.279-.165.616-.247 1.012-.247zm0 .731c-.333 0-.582.116-.747.347-.161.227-.242.559-.242.995 0 .436.08.77.242 1.001.165.23.414.347.747.347.334 0 .582-.116.743-.347.165-.231.247-.565.247-1.001 0-.436-.082-.768-.247-.995-.161-.231-.41-.347-.743-.347zM11.916 17h-.957l-.265-.82H9.22l-.262.82h-.919l1.519-3.998h.83zm-2.465-1.546h1.009l-.508-1.571zm4.004.491.945-2.943h.93L13.855 17h-.83l-1.474-3.998h.968zm3.839-2.943c.477 0 .844.11 1.1.33.257.22.385.531.385.935 0 .337-.104.613-.313.83a1.196 1.196 0 0 1-.516.312l1 1.591h-.946l-.849-1.435-.543-.138V17h-.852v-3.998zm-.682 1.864h.418c.334 0 .564-.042.693-.127.132-.088.198-.24.198-.456a.599.599 0 0 0-.088-.346.463.463 0 0 0-.274-.182 2.005 2.005 0 0 0-.529-.055h-.418z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAvro as FileAvro };
